import React, { useEffect, useState } from "react";
import DeliveryOptions from "../DeliveryOptions/DeliveryOptions";
import { getDelivery } from "../../../../utils/deliveryDateUtils";
import { DateService } from "../../../../utils/dateUtils";

interface DeliveryOptionsContainerProps {
  displayedProduct: any;
  availableDeliveryMethods: any;
  opsLeadTime: number | null;
  setDeliveryMessage: (message: string | null) => void;
  setIsAddToCartDisabled: (disabled: boolean) => void;
}

const DeliveryOptionsContainer: React.FC<DeliveryOptionsContainerProps> = ({
  displayedProduct,
  availableDeliveryMethods,
  opsLeadTime,
  setDeliveryMessage,
  setIsAddToCartDisabled,
}) => {
  const [expressAvailable, setExpressAvailable] = useState(false);
  const [expressCountdown, setExpressCountdown] = useState<string | null>(null);
  const [rapidoDateRange, setRapidoDateRange] = useState<string | null>(null);
  const [standardStartDate, setStandardStartDate] = useState<string | null>(
    null
  );
  const [rapidoCountdown, setRapidoCountdown] = useState<string | null>(null);
  const [standardCountdown, setStandardCountdown] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (
      displayedProduct &&
      displayedProduct.partner &&
      displayedProduct.partner.daysOpen &&
      Object.keys(displayedProduct.partner.daysOpen).length > 0 &&
      opsLeadTime !== null
    ) {
      const deliveryOptions = {
        expressDelivery: availableDeliveryMethods.express || false,
        limitTime: displayedProduct?.logistics?.limitTime,
        daysToDeliver:
          displayedProduct?.logistics?.minDaysToDeliver ??
          displayedProduct?.logistics?.daysToDeliver,
        opsLeadTime: {
          opsLeadTime: opsLeadTime,
          originZone: displayedProduct.partner.originZone,
          destinationZone: displayedProduct.partner.destinationZone,
        },
        daysOpen: displayedProduct?.partner?.daysOpen,
      };

      console.log("deliveryOptions", deliveryOptions);

      // Ensure all required fields are present
      if (
        deliveryOptions.expressDelivery === undefined ||
        !deliveryOptions.limitTime ||
        deliveryOptions.daysToDeliver === undefined ||
        deliveryOptions.opsLeadTime === undefined ||
        !deliveryOptions.daysOpen
      ) {
        throw new Error("Missing required fields in delivery options");
      }

      const deliveryDates = getDelivery(
        deliveryOptions,
        new Date(),
        availableDeliveryMethods
      );

      // Log the raw date string from the calculation
      console.log(
        "Raw standard delivery date:",
        deliveryDates.standard.startDate
      );

      const rapidoDateRange =
        deliveryDates.rapido.isAvailable && availableDeliveryMethods.rapido
          ? deliveryDates.rapido.availableDates.length > 1
            ? `entre ${DateService.formatDeliveryDateForDisplay(
                deliveryDates.rapido.availableDates[0]
              )} y ${DateService.formatDeliveryDateForDisplay(
                deliveryDates.rapido.availableDates[1]
              )}`
            : deliveryDates.rapido.availableDates.length === 1
            ? `el ${DateService.formatDeliveryDateForDisplay(
                deliveryDates.rapido.availableDates[0]
              )}`
            : null
          : null;

      // Use the improved date parsing and formatting from DateService
      const standardStartDate =
        deliveryDates.standard.startDate && availableDeliveryMethods.standard
          ? `A partir del ${DateService.formatDeliveryDateForDisplay(
              deliveryDates.standard.startDate
            )}`
          : "No disponible";

      console.log("Formatted standard date for display:", standardStartDate);

      setExpressAvailable(
        deliveryDates.express.isAvailable && availableDeliveryMethods.express
      );
      setExpressCountdown(deliveryDates.express.countdown);
      setRapidoDateRange(rapidoDateRange);
      setStandardStartDate(standardStartDate);
      setRapidoCountdown(deliveryDates.rapido.countdown);
      setStandardCountdown(deliveryDates.standard.countdown);

      setDeliveryMessage(null);
      setIsAddToCartDisabled(false);
    }
  }, [
    displayedProduct,
    availableDeliveryMethods,
    opsLeadTime,
    setDeliveryMessage,
    setIsAddToCartDisabled,
  ]);

  return (
    <DeliveryOptions
      expressAvailable={expressAvailable}
      expressCountdown={expressCountdown}
      rapidoDateRange={rapidoDateRange}
      standardStartDate={standardStartDate}
      rapidoCountdown={rapidoCountdown}
      standardCountdown={standardCountdown}
    />
  );
};

export default DeliveryOptionsContainer;
